import React from "react";
import MenuBarReports from "./menuBarReports";


function ViewReports() {
  return (
    <>
    
    <MenuBarReports />
    <div className="column is-9" style={{float:'left'}}><iframe title="Reports" width="100%" height="1800" src="https://uio.correovirtual.com:8088/superset/dashboard/4/?standalone=true" /></div>
    
    </>
  );
}
export default ViewReports;